export const EGGSHELL = "#FDFCFC";
export const CREAM = "#F5F3F1";

export const pageColors = {
  default: EGGSHELL,
  cream: CREAM,
  white: "white",
};
